const actions = {
  SET_EXPORTING: 'mailExport/SET_EXPORTING',
}

export const setExporting = (isExporting: boolean) => ({
  type: actions.SET_EXPORTING,
  payload: { isExporting },
})

export default actions
